import useBasicColumnConfig from "../main/config/column/default/BasicColumnConfig";
import DataTableConfig from "../main/config/dataTable/DataTableConfig";
import DataTable, { useDataTable } from "../main/DataTable";
import useEditRowActionConfig from "../main/config/rowAction/default/EditRowActionConfig";
import useDeleteRowActionConfig from "../main/config/rowAction/default/DeleteRowActionConfig";
import useCreateHeaderActionConfig from "../main/config/headerAction/default/CreateHeaderActionConfig";
import useAccessCommander2NConfigCreateRouteConfig from "../../../routes/configs/integrations/accessCommander2N/AccessCommander2NConfigCreateRouteConfig";
import useAccessCommander2NConfigEditRouteConfig from "../../../routes/configs/integrations/accessCommander2N/AccessCommander2NConfigEditRouteConfig";
import { useLanguageContext } from "../../../context/LanguageContext";
import { useAuthContext } from "../../../context/AuthContext";

function AccessCommander2NConfigsDataTable() {
  const { translate } = useLanguageContext();
  const authContext = useAuthContext();

  //Create the datatable config
  const config = new DataTableConfig("access_commanders_configs/units");

  //Set the datatable fetch info
  config.setFetchRequest("integrations/access_commander/units");

  //Set the datatable columns
  config.setColumns([
    useBasicColumnConfig("url"),
    useBasicColumnConfig("api_token"),
    useBasicColumnConfig("username"),
    useBasicColumnConfig("password"),
    useBasicColumnConfig("company_name"),
    useBasicColumnConfig("group_name"),
    useBasicColumnConfig("type"),
  ]);

  //Set the datatable row actions
  config.setRowActions([
    useEditRowActionConfig("integrations/access_commander/unit", useAccessCommander2NConfigEditRouteConfig())
      .setTitle(
        translate("eva.main.entities.states.edit", [
          {
            key: "entities",
            value: translate("eva.main.entities.access_commander_2n_unit"),
          },
        ])
      ),
    useDeleteRowActionConfig("integrations/access_commander/unit")
      .setTitle(
        translate("eva.main.entities.states.delete", [
          {
            key: "entities",
            value: translate("eva.main.entities.access_commander_2n_unit"),
          },
        ])
      )
      .setDisabled(() => !authContext.hasPermission(
        'integrations.access_commander.configs.update'
      )),
  ]);

  //Set the datatable header actions
  config.setHeaderActions([
    useCreateHeaderActionConfig("integrations/access_commander/unit", useAccessCommander2NConfigCreateRouteConfig())
      .setTitle(
        translate("eva.main.entities.states.create", [
          {
            key: "entities",
            value: translate("eva.main.entities.access_commander_2n_unit"),
          },
        ])
      )
      .setDisabled(() => !authContext.hasPermission(
        'integrations.access_commander.configs.update'
      )),
  ]);

  //Set the overall loading groups for the datatable row actions
  config.setRowActionsLoadingGroups(
    (row) => `${config.getDataTableKey()}_update_${row.id}`
  );

  //Create the datatable object
  const dataTable = useDataTable(config);

  return <DataTable controller={dataTable} />
}

export default AccessCommander2NConfigsDataTable;